<template>
  <component :is="currentComponent" :key="deviceClass" />
</template>

<script>
import pcContent from '@/components/ModelThree/pcContent.vue'
import h5Content from '@/components/ModelThree/h5Content.vue'
export default {
  components: { pcContent, h5Content },
  name: 'pageModel3',
  data() {
    return {}
  },
  computed: {
    currentComponent() {
      return this.deviceClass == 'pc' ? 'pcContent' : 'h5Content'
    },
    deviceClass() {
      return this.$store.getters['device/deviceClass']
    },
  },
  created() {
    sessionStorage.removeItem('shortFshort')
  },
  methods: {},
}
</script>
